import { PayPalService as PayPalCoreService } from '@wix/cashier-core/dist/src/services/PayPal';
import {
  type CreateOrderResponse,
  type UpdateOrderResponse,
  type BillingContactResponse,
  type ShippingContactResponse,
} from '@wix/cashier-core/dist/src/services/PayPal/types';
import { type PaymentBreakdown } from '../../types/PaymentBreakdown';
import { transformOrderDataToPayPal } from '../../services/paypal/paypalTransformData';
import { type OrderItem } from '../../types/OrderItem';
import { type AuthParams } from '../../types/AuthParams';

export interface PayPalCreateOrderArgs {
  accountId: string;
  paymentAmount: string;
  paymentBreakdown: PaymentBreakdown;
  orderItems: OrderItem[];
  currencyCode: string;
  requestShipping: boolean;
  sessionId: string;
}

export interface PayPalUpdateOrderArgs {
  accountId: string;
  orderId: string;
  paymentAmount: string;
  paymentBreakdown: PaymentBreakdown;
  orderItems: OrderItem[];
  currencyCode: string;
  requestShipping: boolean;
  chargeId?: string;
  cashierOrderId?: string;
}

export const createOrder = (data: PayPalCreateOrderArgs, auth: AuthParams): Promise<CreateOrderResponse> => {
  return new PayPalCoreService(auth).createOrder(data.accountId, {
    ...transformOrderDataToPayPal(data),
    checkoutSession: data.sessionId,
  });
};

export const updateOrder = (data: PayPalUpdateOrderArgs, auth: AuthParams): Promise<UpdateOrderResponse> => {
  return new PayPalCoreService(auth).updateOrder(data.accountId, data.orderId, {
    ...transformOrderDataToPayPal(data),
    ...(data.chargeId && data.cashierOrderId && { chargeId: data.chargeId, cashierOrderId: data.cashierOrderId }),
  });
};

export const getContactPaymentDetails = async (
  {
    accountId,
    orderId,
    chargeId,
    cashierOrderId,
  }: {
    accountId: string;
    orderId: string;
    chargeId?: string;
    cashierOrderId?: string;
  },
  auth: AuthParams,
): Promise<{ shippingContact: ShippingContactResponse; billingContact: BillingContactResponse }> => {
  const { shippingAddress, billingAddress } = await new PayPalCoreService(auth).getContactPaymentDetails(
    accountId,
    orderId,
    chargeId && cashierOrderId ? { chargeId, cashierOrderId } : undefined,
  );
  return {
    shippingContact: shippingAddress,
    billingContact: billingAddress,
  };
};
